import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router";
import { initGA, trackPageview } from "../utils/gtag";

import NotFound from "../app/not-found";
import Home from "../app/page";
import AboutUs from "../app/about_us/page";
import Contact from "../app/contact_us/page";
import Blog from "../app/blog/page";
import BlogDetial from "../app/blog_detail/page";
import Portfolio from "../app/portfolio/page";
import Services from "../app/services/page";
import ServiceDetail from "../app/service_detail/page";
import Projects from "../app/projects/page";

const GAListener = () => {
    const location = useLocation();

    useEffect(() => {
        trackPageview(location.pathname + location.search);
    }, [location]);

    return null;
};

export const Navigation = observer(() => {
    useEffect(() => {
        initGA(); // Initialize Google Analytics only once
    }, []);

    return (
        <BrowserRouter>
            <GAListener />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/about_us" element={<AboutUs />} />
                <Route path="/contact_us" element={<Contact />} />
                <Route path="/blogs" element={<Blog />} />
                <Route path="/blog_detail/:slug" element={<BlogDetial />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/services" element={<Services />} />
                <Route path="/service_detail/:slug" element={<ServiceDetail />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
});